import { groq } from "next-sanity";
import { NextSeo } from "next-seo";
import { getClient } from "../../lib/sanity.server";
import Newsletter from "../../view/components/Footer/components/Newsletter/Newsletter";
import Footer from "../../view/components/Footer/Footer";
import Header from "../../view/components/Header/Header";
import Hero from "../../view/screens/Blog/components/Hero";
import Featured from "../../view/screens/Blog/components/Featured/Featured";
import Content from "../../view/screens/Blog/components/Content/Content";
import Sidebar from "../../view/screens/Blog/components/Sidebar/Sidebar";
import ServerPagination from "../../view/components/ServerPagination/ServerPagination";

const featuredPostsCount = 3;

export default function BlogPage({ posts, featuredPosts, total }) {
    return (
        <div>
            <Header />
            <NextSeo
                title="Dzobs.com | Blog | Savjeti, vijesti i zanimljivosti za IT zajednicu"
                description="Saznaj šta je novo u domaćoj IT zajednici, nauči kako da unaprijediš karijeru, te koje firme i trendove vrijedi pratiti."
                canonical={`https://www.dzobs.com/blog/`}
            />
            <Hero
                title="Blog"
                subtitle="Saznaj šta je novo u domaćoj IT zajednici, nauči kako da unaprijediš karijeru, te koje firme i trendove vrijedi pratiti."
            />
            <div className="max-w-screen-xl mx-auto px-6 xl:px-0 ">
                <Featured featuredPosts={featuredPosts} />
                <div className="mb-8 leading-loose">
                    <section className="flex flex-col md:flex-row md:space-x-16 body-font overflow-hidden">
                        <div className="md:w-2/3">
                            <Content
                                posts={posts}
                                isHome={true}
                                title="Ostale vijesti"
                            />
                            <ServerPagination
                                perPage={7}
                                activePage={1}
                                total={total}
                                path="/blog/p/1"
                            />
                        </div>
                        <Sidebar />
                    </section>
                </div>
            </div>
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}

export async function getStaticProps() {
    const posts = await getClient().fetch(
        groq`
      *[_type == "post"] {
        _id,
        title,
        publishedAt,
        body,
        author ->{
          name,
          image,
          title,
          slug
        },
        mainImage,
        categories[]->{
          _id,
          title,
          slug
        },
        slug
      } | order(publishedAt desc) [3...10]
      `
    );

    console.log("posts", posts);

    const featuredPosts = await getClient().fetch(
        groq`
      *[_type == "post" && isFeatured == true] {
        _id,
        title,
        publishedAt,
        body,
        author ->{
          name,
          image,
          title,
          slug
        },
        mainImage,
        categories[]->{
          _id,
          title,
          slug
        },
        slug
      } | order(publishedAt desc) [0...3]
      `
    );

    const postsTotal = await getClient().fetch(
        groq`
  count(*[_type == "post"])`
    );

    // const util = require("util");
    // console.log(
    //   util.inspect(posts, { showHidden: false, depth: null, colors: true })
    // );

    return {
        props: {
            posts,
            featuredPosts,
            total: postsTotal - featuredPostsCount,
        },
        revalidate: 10,
    };
}
